import { getCountry, getDistrict, getInterest } from "@/api";
export default {
  name: "registration",
  props: {
    value: Object,
    mode: String,
    passwordRequired: Boolean,
    phoneDisabled: Boolean
  },

  data() {
    return {
      recaptchaConfig: null,
      ready: false,
      showHint: true,
      active: false,
      form: Object.assign({}, this.value) || {},
      ctyOptions: [],
      intOptions: [],
      districtOptions: [],
      rules: {
        phone: [{
          required: true,
          message: this.$t("Please fill in only number"),
          trigger: "blur",
          pattern: /^[0-9]*$/
        }],
        password: [{
          required: this.passwordRequired,
          message: this.$t("8-16 characters with numbers, upper and lower case" //allow special characters, must have at least 1 number, 1 upper case, 1 lower case, min 8 characters, max 16 characters
          ),
          trigger: "blur",
          pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&%^&*()_+]{8,16}$/
        }],
        email: [{
          required: true,
          type: "email",
          message: this.$t("Invalid email address format"),
          trigger: "blur"
        }],
        recaptcha: [{
          required: !(this.mode == 'update' || this.mode == 'transfer'),
          message: this.$t("recaptcha is required"),
          trigger: "blur"
        }]
      }
    };
  },

  async created() {
    if (!(this.mode == 'update' || this.mode == 'transfer')) {
      // Fetch recaptcha config from API
      try {
        const res = await fetch('/api/crm/recaptcha');

        if (res.ok) {
          this.recaptchaConfig = await res.json(); // You can use recaptchaConfig as needed, e.g., store in data or use for validation
          // Example: this.recaptchaConfig = recaptchaConfig;

          console.log('Recaptcha config fetched:', this.recaptchaConfig);
        }
      } catch (e) {
        console.error('Failed to fetch recaptcha config:', e);
      }
    }

    this.form.interest = this.form.interest || [];
    this.ctyOptions = (await getCountry()).map(i => {
      return {
        value: i.id,
        label: i.name
      };
    });

    if (!this.form.country_region) {
      this.form.country_region = this.ctyOptions[0].value;
    }

    this.intOptions = (await getInterest()).map(i => {
      return {
        value: i.id,
        label: i.name
      };
    });

    if (this.form.country_region) {
      await this.loadDistrict();
    }

    this.ready = true;
  },

  watch: {},
  computed: {
    selectedInterestText() {
      if (this.form.interest.length == 0) {
        return this.$t('Select your interests');
      }

      let result = [];
      this.form.interest.forEach(i => {
        result.push(this.intOptions.find(j => j.value == i).label);
      });
      return result.join(", ");
    }

  },
  methods: {
    async loadDistrict() {
      this.districtOptions = [];
      this.districtOptions = (await getDistrict(this.form.country_region)).map(i => {
        return {
          value: i.id,
          label: i.name
        };
      });
    },

    async refreshRecaptcha() {
      try {
        const res = await fetch('/api/crm/recaptcha?ts=' + Date.now());

        if (res.ok) {
          this.recaptchaConfig = await res.json();
        }
      } catch (e) {
        console.error('Failed to refresh recaptcha:', e);
      }
    },

    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          //      console.log(this.form);
          if (this.recaptchaConfig) {
            this.form.recaptcha_token = this.recaptchaConfig.token;
          }

          this.$emit("input", this.form);
          this.$emit("submit");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }

  }
};